import { defineComponent as _defineComponent } from 'vue';
import { generateTwicPicBackgroundImageSet } from '~/composables/useResponsiveBackground';
import { useGetTranslations } from '~/composables/useGetTranslations';
export default /*#__PURE__*/_defineComponent({
  __name: 'AzEssentialOilGuideCard',
  setup: function setup(__props) {
    var _useNuxt2App = useNuxt2App(),
      $config = _useNuxt2App.$config;
    var _useGetTranslations = useGetTranslations(),
      translate = _useGetTranslations.translate;
    var backgroundImage = computed(function () {
      return generateTwicPicBackgroundImageSet($config.public.cloudinaryDomain, '//images.ctfassets.net/0xsz2r7o7t3z/6od91pxVT5gltwousKdald/0cd6fdc069632931042991adabd89210/banner_guide_huiles_essentielles_4.jpg', 690);
    });
    return {
      __sfc: true,
      $config: $config,
      translate: translate,
      backgroundImage: backgroundImage
    };
  }
});